import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getCasosViolencia from '../../../graphql/querys/violenciaGenero/getCasosViolencia.graphql';
import deleteCasoViolencia from '../../../graphql/mutations/violenciaGenero/deleteCasoViolencia.graphql';
import getPersonaPorId from '../../../graphql/querys/personas/getPersonaPorId.graphql';

import TablaCasos from './TablaCasos';
import getCantidadCasosViolenciaConFiltros from '../../../graphql/querys/violenciaGenero/getCantidadCasosViolenciaConFiltros.graphql';
import getCasosViolenciaConFiltros from '../../../graphql/querys/violenciaGenero/getCasosViolenciaConFiltros.graphql';

const confirm = Modal.confirm;
@compose(
  graphql(deleteCasoViolencia, {
    name: 'deleteCasoViolencia',
    options: {
      refetchQueries: [{ query: getCasosViolencia }],
    },
  })
)
class ListarCasos extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      imprimir: false,
      fechaInicial: fechaIni,
      fechaFinal: fechaFin,
      datosImpresion: {},
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.
    console.log('Se desea eliminar el caso de violencia con id ', id);

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este caso de violencia de genero?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteCasoViolencia({
            variables: { _id: id },
          })
          .then(res => {
            // console.log("La respuesta del delete fue....");
            // console.log(res);

            let id = res.data.deleteCasoViolencia;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);

              notification.warning({
                message: 'Caso de Violencia eliminado',
                description:
                  'Se ha eliminado el caso de violencia exitosamente',
              });
            }
          })
          .catch(err => {
            console.log(
              'Existio un error a la hora de eliminar el caso de violencia de genero'
            );
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion el caso de violencia de genero ',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.lista, caso => {
      return (
        caso.victima.nombre.toUpperCase().indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.lista, caso => {
      return (
        caso.victima.apellido.toUpperCase().indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loadingTabla: true,
    });

    let listaFiltrada = _.filter(this.state.lista, caso => {
      return (
        caso.victima.num_doc.toUpperCase().indexOf(filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loadingTabla: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps.data.getCasosViolencia) {
  //     this.setState(
  //       {
  //         ...this.state,
  //         listaTotal: nextProps.data.getCasosViolencia,
  //         primeraCarga: false,
  //       },
  //       function() {
  //         this.ordenarLista(1, 10);
  //       }
  //     );
  //   }
  // }

  componentDidMount() {
    this.buscarCasosViolencia();
  }

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    // console.log("Listaaaa");
    // console.log(this.state.listaTotal);
    this.setState({
      loadingTabla: true,
    });
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        caso => {
          return caso.fecha;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
      loadingTabla: false,
    });
  };

  onImprimir = registro => {
    // console.log("El registro que me llego es.....");
    // console.log(registro);

    this.setState(
      {
        ...this.state,
        loading: true,
      },
      () => {
        this.props.client
          .query({
            query: getPersonaPorId,
            variables: {
              _id: registro.victima._id,
            },
          })
          .then(respuesta => {
            let persona = respuesta.data.getPersonaPorId;
            let datosImpresion = {
              ...persona,
              fecha_creacion: new Date(registro.fecha_creacion),
              ...registro,
              declaracion_jurada: registro.declaracion,
              fecha_nacimiento: persona.fecha_nacimiento
                ? moment(persona.fecha_nacimiento).toDate()
                : '',
              edad: persona.fecha_nacimiento
                ? Math.floor(
                    moment(new Date()).diff(
                      moment(persona.fecha_nacimiento),
                      'years',
                      true
                    )
                  )
                : '',
            };

            // console.log("Los datos de impresion es....");
            // console.log(datosImpresion);

            this.setState({
              ...this.state,
              loading: false,
              datosImpresion,
              imprimir: true,
            });
          })
          .catch(err => {
            console.log('Error en la obtencion de los datos de la persona');
            console.log(err);
          });
      }
    );
  };

  buscarCasosViolencia = () => {
    this.setState({ loadingTabla: true });
    // console.log('ENTRE A BUSCAR CASOS');
    this.props.client
      .query({
        query: getCantidadCasosViolenciaConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicial,
          fechaFinal: this.state.fechaFinal,
          filtroOrganismo:
            this.props.usuario && this.props.usuario.organismo
              ? this.props.usuario.organismo._id
              : null,
        },
        fetchPolicy: 'network-only',
      })
      .then(resp => {
        // console.log('CANTIDAD RECIBIDA DE CASOS: ', resp);
        if (
          resp.data.getCantidadCasosViolenciaConFiltros ||
          resp.data.getCantidadCasosViolenciaConFiltros == 0
        ) {
          this.setState({
            cantidadTotal: resp.data.getCantidadCasosViolenciaConFiltros,
          });

          this.props.client
            .query({
              query: getCasosViolenciaConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicial,
                fechaFinal: this.state.fechaFinal,
                filtroOrganismo:
                  this.props.usuario && this.props.usuario.organismo
                    ? this.props.usuario.organismo._id
                    : null,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              // console.log('CASOS: ', res);
              this.setState(
                {
                  ...this.state,
                  listaTotal: res.data.getCasosViolenciaConFiltros,
                  listaOriginal: res.data.getCasosViolenciaConFiltros,
                  primeraCarga: false,
                  loadingTabla: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL CASOS DE VIOLENCIA POR RANGO: ');
              console.log(err);

              Modal.error({
                title: 'Error en la busqueda de casos de violencia',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE CASOS DE VIOLENCIA'
        );
        console.log('EL ERROR ES: ', err);
      });
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        // console.log('CAMBIE A LA PAGINA: ', pagina);
        this.buscarCasosViolencia();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChangeFechas = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicial: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFinal: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
        pagina: 1,
      },
      () => {
        this.buscarCasosViolencia();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaCasos
          casos={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          onChange={this.onChangeFechas}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          filtrarPorDocumento={this.filtrarPorDocumento}
          fechaInicial={this.state.fechaInicial}
          fechaFinal={this.state.fechaFinal}
          pagina={this.state.pagina}
          cambiarPagina={this.cambiarPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          cantidadPorPagina={this.state.cantidadPorPagina}
          loadingTabla={this.state.loadingTabla}
        />
      </div>
    );
  }
}

export default withApollo(ListarCasos);
